
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7H20V10H2V7ZM11.1 17C11.0344 16.6769 11 16.3425 11 16C11 15.2889 11.1484 14.6125 11.416 14H2V17H11.1ZM16 11.4539C15.4477 11.4539 15 11.9016 15 12.4539V19.4539C15 20.0061 15.4477 20.4539 16 20.4539H22C22.5523 20.4539 23 20.0061 23 19.4539V12.4539C23 11.9016 22.5523 11.4539 22 11.4539H16ZM17.6666 12.9536H16.5999V13.9536H17.6666V12.9536ZM18.7333 12.9536H21.3999V13.9536H18.7333V12.9536ZM17.6666 15.4537H16.5999V16.4537H17.6666V15.4537ZM16.5999 17.9538H17.6666V18.9538H16.5999V17.9538ZM21.3999 15.4537H18.7333V16.4537H21.3999V15.4537ZM18.7333 17.9538H21.3999V18.9538H18.7333V17.9538Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowFormAssignmentFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
